import { FC, useMemo, useId } from "react";
import styles from "./MultiCheckbox.module.css";

interface MultiCheckboxValue {
  id: string;
  title: string;
  selected?: boolean;
  disabled?: boolean;
}

interface MultiCheckboxProps {
  values: MultiCheckboxValue[];
  onUpdate?: (id: string, checked: boolean) => void;
  disabled?: boolean;
}

const MultiCheckbox: FC<MultiCheckboxProps> = ({ values, disabled, onUpdate }: MultiCheckboxProps) => {
  const idPrefix = useId();
  const sortedValues = useMemo(() => [...values].sort((a, b) => a.title.localeCompare(b.title)), [values]);

  return (
    <fieldset className={styles.multiCheckBox}>
      <div className={styles.list}>
        {sortedValues.map((x) => {
          const inputId = `${idPrefix}-${x.id}`;
          const isDisabled = x.disabled || disabled;

          return (
            <div className={styles.multiCheckBoxItem} key={`cb_${x.id}`}>
              <label className={styles.multiCheckBoxLabel} htmlFor={inputId}>
                {x.title}
              </label>
              <input
                type="checkbox"
                id={inputId}
                value={x.id}
                checked={!!x.selected}
                disabled={isDisabled}
                onChange={(e) => onUpdate?.(x.id, e.currentTarget.checked)}
              />
            </div>
          );
        })}
      </div>
    </fieldset>
  );
};

export default MultiCheckbox;
